import { fn, hash } from '@ember/helper';
import fuiSlider from 'wise-fui-modules/modifiers/fui-slider';
import FeelingEvasSliderComponent, {
  type FeelingEvasSlidersSignature
} from './component';

export default class FeelingEvasMoodSlider extends FeelingEvasSliderComponent<FeelingEvasSlidersSignature> {
  static override max = 5;
  static override min = -5;

  <template>
    {{! prettier-ignore }}
    <div
      class={{this.styles.slider}}
      ...attributes
      {{fuiSlider min=this.min max=this.max step=0.1 start=@start onChange=@onChange autoAdjustLabels=false interpretLabel=(fn this.labels (hash
            0="<i class='hourglass outline large red icon'></i>"
            50="<i class='hourglass half end large grey icon'></i>"
            100="<i class='hourglass large green icon'></i>"
          )
        )
      }}
    ></div>

    <div class={{this.styles.hints}}>
      <span class='ui small grey text'>durée courte ({{this.min}})</span>
      <span class='ui small grey text'>durée longue ({{this.max}})</span>
    </div>
  </template>
}
